module.exports = __webpack_public_path__ + "img/royal-crown-with-three-picks-svgrepo-Gold.998b67d9.png";